import { useMutation } from "@tanstack/react-query";

import { executeEmServiceCommand } from "@/api/machines/em-api-v2";

export const useEmServiceCommand = () =>
	useMutation({
		mutationFn: executeEmServiceCommand,
	});
